import React from 'react';

import {
  Modal,
  Button,
  // FormControl,
  // FormGroup,
  // ControlLabel,
  // Col,
  Row,
  // Well
} from 'react-bootstrap';

// import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
// import RequiredMark from '../../../commonComponents/RequiredMark';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
// import custJqAjax from '../../../commonJS/custJqAjax';


export default class KeyPartStockModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      onChange: (selection, id, cb) => {

        let len = selection.length, arrSelections = [];
        for (let i = 0; i < len; i++) {
          arrSelections.push(selection[i].value);
        }

        this.setState({ arrSelections, accessoryPackages: selection });

      },
      saveKeyPart: () => {
        // test ==
        const accessories = this.props.accessories.slice(),
          optsAcces = this.props.optsAcces.slice(),
          tempArr = [];
        // 將配件包內容組合成一個陣列 
        for (let i = 0, len = this.state.accessoryPackages.length; i < len; i++) {
          const accesIds = this.state.accessoryPackages[i].accessoryIds,
            accesVol = this.state.accessoryPackages[i].accessoryVol;
          // 組成id陣列     
          tempArr.push(...accesIds);
          // 與配件既有數量相加
          for (let i = accesIds.length - 1; i >= 0; i--) {
            const ind = this.props.findIndex(optsAcces, { value: accesIds[i] });
            // 原本有選才相加，否則只計算本身
            if (accessories.indexOf(accesIds[i]) !== -1) {
              optsAcces[ind].vol += accesVol[i];
            } else {
              optsAcces[ind].vol = accesVol[i];
            }
            // 更新配件label
            optsAcces[ind].label = optsAcces[ind].orinLabel + ` * ${optsAcces[ind].vol}`;
          }

        }

        // 取聯集後更新
        const newArr = this.props.union(accessories, tempArr),
          vol = this.props.currAccessoryId ? optsAcces[this.props.findIndex(optsAcces, { value: this.props.currAccessoryId })].vol : "";

        this.props.parentStateHandler({ states: ['accessories', 'showPackageUI', 'optsAcces', 'currAccessoryVol'], newValues: [newArr, false, optsAcces, vol] });
        return;
        // ===

        // const productId = this.props.productId,
        //       keyPartIds = this.state.arrSelections,
        //       len = keyPartIds.length;

        // let keyPartNum = this.props.filteredKeyParts.length;

        // // for 迴圈加入多筆
        // for(let i = 0; i < len; i++) {
        //   keyPartNum++;
        //   let formData = new FormData();

        //   formData.append('product_id_new', productId);
        //   formData.append('part_id_ref', keyPartIds[i]);
        //   formData.append('sort_pos', keyPartNum);

        //   custJqAjax({
        //     type: 'POST',
        //     url: `/api/W_ServiceSky_Product_Issue_Relation_Product_Part_Post.php`,
        //     data: formData,
        //     processData: false,
        //     contentType: false,
        //     success: res => { }
        //   });
        // }


        // this.props.keyPartsListUpdater('create', '', keyPartIds);

        // this.props.parentStateHandler({states: ['keyPartEditMode', 'showKeyPartStockModal'], newValues: ['view', false]});
      },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
      optsSortGen: len => {
        len++;
        let arr = [];
        for (let i = 1; i < len; i++) {
          arr.push({ value: i, label: i });
        }

        return arr;
      }
    }

    this.funcs = {
      closeModal: () => {
        this.props.parentStateHandler({ states: 'showPackageUI', newValues: false });
      },
      optsGenerator: arr => {
        if (!arr) return [];
        let opts = arr.map((item, ind) => {
          return { value: item.id, label: item.name_tw }
        });
        return opts;
      }
    }


    this.state = {
      // optsSort: [],
      // sort: 0,
      accessoryPackages: [],
      optsKeyPart: [],
      arrSelections: [],
      // common
      btnSaveDisable: true
      // btnDeleteDisable: true,
      // onEdit: this.props.keyPartEditMode === 'edit' ? true : false,
      // onCopy: false,
      // editMode: "View",
      // editPermission: true
    }
  }


  componentDidMount() {
    // 產生keyparts選項
    const optsKeyPart = this.funcs.optsGenerator(this.props.filteredKeyPartsList);

    this.setState({ optsKeyPart });
    document.getElementById('sel-key-part-list').focus();
  }

  componentDidUpdate() {
    // 資料驗證ok才可送出
    if (this.state.arrSelections.length === 0) {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) this.setState({ btnSaveDisable: false });
  }

  render() {

    let saveBtn = "",
      // deleteBtn = "",
      // editable = 1,
      // modeBtns = "",
      // productId = "",
      saveBtnText = '儲存';

    // if(this.props.params) productId = this.props.params.productId;
    // else  productId = this.props.productId;

    saveBtn = (
      <Button disabled={this.state.btnSaveDisable}
        onClick={() => { this.handlers.saveKeyPart(this.state.onEdit ? 1 : 0) }}
        style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
        {saveBtnText}
      </Button>
    );

    // deleteBtn = this.state.onEdit ? 
    //               <DeleteBtnWithConfirm
    //                 style={{float: "right", marginLeft: 5, position: "relative", zIndex: "3"}}
    //                 onClick={this.handlers.deleteProduct}
    //                 title="Are you sure?" />
    //             : "";

    const tempOptsPacks = [
      { value: 1, label: '自動工具組', accessoryIds: [5, 6, 7], accessoryVol: [1, 2, 1] },
      { value: 2, label: '材料回收套件', accessoryIds: [2, 4, 6], accessoryVol: [2, 1, 1] }
    ];

    return (
      <Modal id="modal-key-part-stock" keyboard={false} backdrop="static" show={true} onHide={this.funcs.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              <span>
                從選配組合加入配件
              </span>
            </span>
            <Button onClick={this.funcs.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>

            <DropDownMenu
              id='sel-key-part-list'
              multi={true}
              sm={12}
              required={false}
              label="請選擇選配組合 (可多選。)"
              value={this.state.arrSelections}
              stateName="arrSelections"
              onChange={this.handlers.onChange}
              options={tempOptsPacks || this.state.optsKeyPart} />

          </Row>

        </Modal.Body>
        <Modal.Footer>
          {/*
          <Button onClick={this.funcs.closeModal} style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>取消</Button>
          {saveBtn}
        */}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/salesCases/KeyPartStockModalCt.jsx